// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyCYv7UOUbt4hzJDQndRvtm0wOebRlsL-6I",
  authDomain: "friend-a-book.firebaseapp.com",
  projectId: "friend-a-book",
  storageBucket: "friend-a-book.appspot.com",
  messagingSenderId: "715755921107",
  appId: "1:715755921107:web:724ddaa668e1913743be26",
  measurementId: "G-06P8PD04TD"
};